import React, { useRef,useState,useEffect } from 'react';
import { Container, Row,Col } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from "react-slick";
import HTMLReactParser from "html-react-parser";
import { isIOS } from 'react-device-detect';
import "./Counter.scss"
import { graphql, useStaticQuery } from "gatsby";
import banerDesk from '../../images/bg_1400.jpg' 
// import banerDesk from '../../images/bg_1400.jpg' 

const Counter = (props) => {
    const stats = useStaticQuery(graphql`
        query {
            glstrapi {
                globalModule {
                    Site_Stats {
                        _id
                        Title
                        Sort
                        Publish
                        Description
                    }
                }
            }
        }
    `);

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 8000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 3000,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:3,   
                }
            },
            {
                breakpoint:1700,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:2,
                }
            
            },
            {
                breakpoint:1500,
                settings: {
                    slidesToShow:3,
                    slidesToScroll:2,                
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            }
        ]
    };
    let titleText = "";
    if(props?.data?.Title) {
        titleText = props?.data?.Title?.replace(props?.data?.Italic_Text, `<span><span class="text-color">${props?.data?.Italic_Text}</span></span>`);
    }

    const [renderComponent, setRenderComponent] = useState(false);
    useEffect(() => {
        if (isIOS) {
          setRenderComponent(true)
        }else {
        window.addEventListener("mousemove", () => {
        if (renderComponent === false) {
          setRenderComponent(true)
        }
        })
        window.addEventListener("touchmove", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })
        window.addEventListener("keypress", () => {
            if (renderComponent === false) {
            setRenderComponent(true)
            }
        })}
    }, [])
    return (
        <section className= "counter" >
            <Container>
                <Row>
                    <Col>
                        {(props?.data?.Sm_Title || (titleText && titleText.trim()) || props?.data?.Content) && (
                            <div className="counter-heading">
                                {props?.data?.Sm_Title && <span className="sub-title">{props?.data?.Sm_Title}</span>}
                                {titleText && titleText.trim() && <h2>{HTMLReactParser(titleText)}</h2>}
                                {props?.data?.Content && <React.Fragment>
                                    {HTMLReactParser(props?.data?.Content)}
                                </React.Fragment>}
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row className="d-lg-none">
                    {stats?.glstrapi?.globalModule?.Site_Stats.map((stat, i) => 
                        <div className="col-6 col-md-6 col-xl-3" key={i}>
                            <ScrollAnimation animateIn='fadeInUp' delay={500} className="total-block">
                                <div className="total-record records">
                                    <span className="total-count">
                                        {stat.Title}
                                    </span>
                                    <p className="sm-content">
                                        {stat.Description}
                                    </p>
                                </div>
                            </ScrollAnimation>
                        </div>
                    )}
                </Row>
                <div className="counter-slider d-none d-lg-block">
                    <Slider className="slick-arrow" {...settings}>
                        {stats?.glstrapi?.globalModule?.Site_Stats.map((stat, i) => <div className="total-record" key={i}>
                            <span className="total-count">{stat.Title}</span>
                            <p className="sm-content">
                                {stat.Description}
                            </p>
                        </div>)}
                    </Slider>
                </div>
            </Container>
        </section>
    )
};
export default Counter